import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentFactory, ComponentRef } from '@angular/core';
import { NodoEntity, FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';
import { ColumnaComponent } from '../columna/columna.component';

@Component({
  selector: 'app-fila',
  templateUrl: './fila.component.html',
  styleUrls: ['./fila.component.css']
})
export class FilaComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() nodos: NodoEntity[] = [];
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() classShared: string;
  @Input() index: number;
  @ViewChild('rowContainer', { read : ViewContainerRef }) rowContainer: ViewContainerRef;

  columnas: number;
  columnClassShared: string;

  constructor( private componentFactory: ComponentFactoryResolver) { }

  ngOnInit() {
    this.columnClassShared = this.classShared && this.classShared.length > 0 ? this.classShared : 'col-6';
    this.onBuild();
  }

  // Generador

  onClean() {
    this.rowContainer.clear();
  }

  onBuild() {
    // Limpieza
    this.onClean();
    let index = -1;
    this.columnas = 0;
    // Generarar Columnas
    if (this.nodos) {
      if (this.nodos.length === 1) {
        const nodo = this.nodos[0];
        let className = 'col-12';
        if (nodo && nodo.codigoOrientacion === 1) {
          className = this.columnClassShared;
        }
        this.columnas++;
        index++;
        const col = this.getCol(className, this.nodos[0], this.filtros, index);
      } else {
        this.columnas++;
        index++;
        const col1 = this.getCol(this.columnClassShared, this.nodos[0], this.filtros, index);
        this.columnas++;
        index++;
        const col2 = this.getCol(this.columnClassShared, this.nodos[1], this.filtros, index);
      }
    }
  }

  getCol(className: string, nodo: NodoEntity, filtros: FiltrosFormatoAsistencialEntity, index: number): ComponentRef<ColumnaComponent> {
    const factory: ComponentFactory<ColumnaComponent> = this.componentFactory.resolveComponentFactory(ColumnaComponent);
    const component: ComponentRef<ColumnaComponent> = this.rowContainer.createComponent(factory);
      component.instance.className = className;
      component.location.nativeElement.className = className;
      component.instance.nodo = nodo;
      component.instance.filtros = filtros;
      component.instance.data = this.data;
      component.instance.index = index;
      component.instance.onDelete = () => {
        this.onDetach(nodo, component.instance.index, component);
      };
    return component;
  }


  // Auxiliar
  onDetach(nodo: NodoEntity, index: number, component: any) {
    const idx = this.rowContainer.indexOf(component);
    this.rowContainer.remove(idx);
    this.columnas--;
    if (this.columnas === 0) {
      setTimeout(() => {
        this.onDelete();
      }, 50);
    }
  }

  onDelete() {}
}
